import { GroupingHeader } from '@core/components'
import type { MapFetchingResult } from '@core/core/types'
import type { FC } from 'react'

import css from './Statistics.css'
import { StatisticsBlock } from './StatisticsBlock'

export type StatisticsProps = Pick<MapFetchingResult, 'before' | 'after'>

export const Statistics: FC<StatisticsProps> = ({ before, after }) => {
  return (
    <div>
      <GroupingHeader className={css.statisticsHeader} title="Статистика по отклонению" />
      <div className={css.statistics}>
        <StatisticsBlock text="До подсадки" {...before} />
        <StatisticsBlock text="После подсадки" {...after} />
      </div>
    </div>
  )
}
